import { WppTypography } from '@wppopen/components-library-react'
import clsx from 'clsx'
import type { ReactNode } from 'react'
import styles from './TitleWithSubtitleCell.module.scss'

interface TitleWithSubtitleCellProps {
  title: string | ReactNode
  subTitle: string
  subtitleClassName?: string
  icon?: ReactNode
}

export default function TitleWithSubtitleCell({
  title,
  subTitle,
  subtitleClassName,
  icon,
  ...props
}: TitleWithSubtitleCellProps) {
  return (
    <div className={styles.cell} {...props}>
      <WppTypography tag="p" type="s-body">
        {title}
      </WppTypography>

      <span className={styles.subTitleContainer}>
        <WppTypography
          tag="p"
          type="xs-body"
          className={clsx(subtitleClassName, { [styles.subtitle]: !subtitleClassName })}
        >
          {subTitle}
        </WppTypography>
        {icon}
      </span>
    </div>
  )
}
